export const subPermissionKeys = {
  groupKey: 'student',

  read: 'student_records-listar-record-estudiantil-graduate',
  getOnlyPrincipalEduLvls: 'education-levels-obtener-nivel-educativo-principal',
  getOnlyCarrers: 'education-levels-obtener-nivel-educativo',
  graduateStudent: 'student_records-graduar-estudiante',
};
